import React from 'react';
import { getPatient } from '@bforms-web/common';

import PatientView, { GetPatientProps } from '../../components/Patient/DetailedView';

const dispatchers: GetPatientProps = {
  getPatient,
};

export default function PatientViewComposer(): JSX.Element {
  return <PatientView {...dispatchers} />;
}
